import React from 'react';
import _ from 'lodash';
import OrganizationUnitSocialInfoComponent from './organization-unit-socialInfo.component';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import MediaInfoComponent from '../../../../../../common/components/common/media-info.component';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../../redux/library/selector';

export const OrganizationUnitMediaComponent = ({ socialProfileType, onFormSocialProfileItemChange, getIsSocialProfilesRecordDeletable, deleteSelectedSocialProfiles, socialProfiles, changeImage, mediaFiles, fileTypes, onFormItemChange, handleOpen, deleteSelectedMedia, handleClose, openConfirmation }: any) => {
  const libraryData = useSelector(selectListItems)
  return (
    <>
    <AccordionContainer
    child={
<MediaInfoComponent
            changeImage={changeImage}
            fileTypes={libraryData?.result?.FileType}
            onFormItemChange={onFormItemChange}
            mediaFiles={mediaFiles}
            />
          }
          expandedPanel="mediaInfo"
          headerTitle="Media Information"
      />
<AccordionContainer
    child={
      <div className=' w-full'>
                {_.map(
                  socialProfiles,
                  (selectedSocialProfile: any, index: any) => (
                  
                    <OrganizationUnitSocialInfoComponent
                        deleteSelectedSocialProfiles={deleteSelectedSocialProfiles}
                        getIsSocialProfilesRecordDeletable={getIsSocialProfilesRecordDeletable}
                        handleClose={handleClose}
                        handleOpen={handleOpen}
                        itemIndex={index}
                        onFormSocialProfileItemChange={onFormSocialProfileItemChange}
                        openConfirmation={openConfirmation}
                        selectedSocialProfile={selectedSocialProfile}
                        socialProfileType={socialProfileType}
                    />
                   
                  )
                )}

</div>
                  }
    expandedPanel="Social Profile"
    headerTitle="Social Profile"
/>
    </>
  )
}
export default OrganizationUnitMediaComponent;
